import React, { useEffect } from 'react'

import { QuizConfig, QuizStep } from '@f/applications/QuizApp/partials/types'

export const useCheckoutContentOverrides = (
  steps: QuizStep[],
  updateSteps: React.Dispatch<React.SetStateAction<QuizStep[]>>,
  quizConfig: QuizConfig
) => {
  const selectedCustomCheckoutContentIds = getAllSelectedCustomCheckoutContentIds(
    steps
  )

  useEffect(() => {
    updateSteps(currentSteps =>
      currentSteps.map((step, index) => {
        if (step.checkout) {
          const override = step.custom_content?.find(({ id }) =>
            selectedCustomCheckoutContentIds.includes(id)
          )

          if (override) {
            return {
              ...step,
              cta_copy: override.cta_copy || step.cta_copy,
              heading: override.heading || step.heading
            }
          }
          // covers scenario when user goes back and changes a value
          return {
            ...step,
            cta_copy: quizConfig.steps[index].cta_copy,
            heading: quizConfig.steps[index].heading
          }
        }

        return step
      })
    )
  }, [selectedCustomCheckoutContentIds.length])
}

const getAllSelectedCustomCheckoutContentIds = (steps: QuizStep[]) =>
  steps.reduce((acc: string[], currentStep) => {
    for (const { value } of currentStep.values) {
      if (value) {
        const custom_checkout_content_id = currentStep.options?.find(option =>
          Array.isArray(value)
            ? value.includes(option.value)
            : option.value === value
        )?.custom_checkout_content_id
        if (custom_checkout_content_id) {
          acc.push(custom_checkout_content_id)
        }
      }
    }

    return acc
  }, [])
